import React from 'react';
import { Helmet } from 'react-helmet';
import _isEmpty from 'lodash/isEmpty';
import { constructSEODefaultCanonicalUrl, getPageType } from '../../helpers/Utils/seoHelper';
import pageIndex from '../../helpers/Utils/PageIndexHelper';

/** *
 * @props seoBlock
 * @props preferences
 * @props deviceType
 * @props canonicalURL
 * @props noIndexNoFollowRequired
 * @props enableCanonicalFallback
 */

const SeoMetaTags = (prop) => {
    /** *
     * @params seoBlock expecting to contains data like
     * seoMetaTitle : "JCPenney: Window & Home Decor, Bedding, Appliances & Clothing",
     * seoMetaKeyword": "",
     * seoMetaDescription": "Enjoy great deals on furniture, bedding, window & home decor"
     * searchTerms": "",
     */
    const {
        enableCanonicalFallback = true,
        enableIrisManualIndexing = true,
        hostname = 'www.jcpenney.com',
        noIndexNoFollowRequired = false,
        location = {},
        preferences: { seoConfig: { excludeQueryParams = [], includeQueryParams = [] } = {} } = {},
        seoBlock = {},
    } = prop;
    /* istanbul ignore next */
    const metaTags = seoBlock;
    /**
     * @params cannonical should forward from microsite.
     */
    /* istanbul ignore next */

    let canonicalURL = '';
    const seoRobotsTag = {
        name: 'robots',
    };
    /* istanbul ignore else */

    if (enableIrisManualIndexing) {
        seoRobotsTag.content = pageIndex({
            pageIndex: metaTags?.pageIndex,
            noIndexNoFollowRequired,
            noIndexNoFollow: metaTags?.noIndexNoFollow,
            robots: metaTags?.robots,
        });
    } else if (noIndexNoFollowRequired) {
        seoRobotsTag.content = {
            content: 'noindex, nofollow',
        };
    }
    try {
        canonicalURL = metaTags.canonicalUrl;

        if (enableCanonicalFallback && _isEmpty(canonicalURL) && !_isEmpty(location)) {
            const pageType = getPageType(location?.pathname);
            /* except pdp and plp/srp for all remaining microites we should not include parameters part of the canonical url */
            if (pageType === 'g' || pageType === 's' || pageType === 'p') {
                const urlParams = constructSEODefaultCanonicalUrl(
                    location?.search,
                    excludeQueryParams,
                    includeQueryParams,
                    false
                );
                canonicalURL =
                    !_isEmpty(urlParams) && `https://${hostname}${location?.pathname}${urlParams}`;
            } else {
                canonicalURL = `https://${hostname}${location?.pathname}`;
            }
        } else if (_isEmpty(canonicalURL)) {
            const url = !__SERVER__ && window ? window.location.href : '';
            const pageType = getPageType(url);
            /* except pdp and plp/srp for all remaining microites we should not include parameters part of the canonical url */
            const removeAllParams = !(pageType === 'g' || pageType === 's' || pageType === 'p');
            const defaultURL = constructSEODefaultCanonicalUrl(
                !__SERVER__ && window ? window.location.href : '',
                excludeQueryParams,
                includeQueryParams,
                removeAllParams
            );
            canonicalURL = canonicalURL || defaultURL;
        }
    } catch (error) {
        /* istanbul ignore next */
        console.warn('SEO regularexpression failed');
    }
    return (
        <div className="application">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaTags.pageTitle}</title>
                <meta name="description" content={metaTags.metaDescription} />
                <meta name="keywords" content={metaTags.keywords} />
                <link rel="canonical" href={canonicalURL} />
                {seoRobotsTag.content && <meta {...seoRobotsTag} />}
            </Helmet>
        </div>
    );
};

export default SeoMetaTags;
